module.exports = __webpack_public_path__ + "img/icon_no.c29f2633.png";